import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAdvisorStore } from "@/features/auth/stores/advisorStore";
import { Button, Input, Card, CardContent } from "@/shared/components/ui";
import { LogIn, AlertCircle } from "lucide-react";

export function LoginPage() {
  const navigate = useNavigate();
  const { login, isLoading, error, clearError } = useAdvisorStore();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();

    try {
      await login(email, password);
      navigate("/");
    } catch {
      // Error is handled by the store
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Panel Doradcy</h1>
          <p className="text-gray-600 mt-2">Zaloguj się do swojego konta</p>
        </div>

        <Card>
          <CardContent className="p-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <div className="p-3 bg-error-50 border border-error-200 rounded-lg flex items-start gap-2">
                  <AlertCircle className="w-5 h-5 text-error-600 flex-shrink-0 mt-0.5" />
                  <p className="text-sm text-error-700">{error}</p>
                </div>
              )}

              <Input
                label="Email"
                type="email"
                placeholder="jan.kowalski@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />

              <Input
                label="Hasło"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />

              <Button
                type="submit"
                className="w-full"
                isLoading={isLoading}
                leftIcon={<LogIn className="w-4 h-4" />}
              >
                Zaloguj się
              </Button>
            </form>

            <div className="mt-6 text-center text-sm text-gray-600">
              Nie masz konta?{" "}
              <Link
                to="/register"
                className="text-primary-600 hover:text-primary-700 font-medium"
              >
                Zarejestruj się
              </Link>
            </div>
          </CardContent>
        </Card>

        <p className="mt-6 text-center text-sm text-gray-500">
          <Link to="/admin/login" className="hover:text-gray-700">
            Panel administratora
          </Link>
        </p>
      </div>
    </div>
  );
}
